import { Palette } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { useThemeStore } from '@/store/theme';

export function ThemeSwitcher() {
  const { t } = useTranslation();
  const { themes, currentThemeId, setThemeId } = useThemeStore();
  const prebuilt = themes.filter(th => th.kind === 'prebuilt' || th.kind === 'prebuilt-custom');
  const custom = themes.filter(th => th.kind === 'user-custom');
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title={t('theme.label')}>
          <Palette className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>{t('theme.menuLabel')}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {prebuilt.map(th => (
          <DropdownMenuItem key={th._id} onClick={() => setThemeId(th._id)}>
            <span className="h-3 w-3 rounded-full border" style={{ background: th.colors.primary }} />
            <span className="flex-1">{th.name}</span>
            {currentThemeId === th._id && <span className="text-xs text-muted-foreground">●</span>}
          </DropdownMenuItem>
        ))}
        {custom.length > 0 && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuLabel className="text-xs text-muted-foreground">Custom</DropdownMenuLabel>
            {custom.map(th => (
              <DropdownMenuItem key={th._id} onClick={() => setThemeId(th._id)}>
                <span className="h-3 w-3 rounded-full border" style={{ background: th.colors.primary }} />
                <span className="flex-1">{th.name}</span>
                {currentThemeId === th._id && <span className="text-xs text-muted-foreground">●</span>}
              </DropdownMenuItem>
            ))}
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
